import { useAuth } from '@features/auth/hooks/useAuth';
import styles from './logout-button.module.scss';
import { useNavigate } from 'react-router-dom';
import LogoutIcon from './logout-icon';
import { FC } from 'react';

export const LogoutButton: FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  return (
    <button className={styles.button} onClick={handleLogout}>
      Выйти <LogoutIcon />
    </button>
  );
};
